import Request from '@/api/request';
import { IStatement, ICreateStatementResponse } from '@/types/services';

const api = new Request('lk/');

export function createStatement(
  data: IStatement
): Promise<ICreateStatementResponse> {
  return api.post('statement/create', data).then((res: any) => res);
}

export function getStatementById(id: string): Promise<object> {
  return api
    .get(`statement/statementInfo?statementId=${id}`)
    .then((res: any) => res);
}

export function createStatementXml(id: string): Promise<object> {
  return api
    .get(`statement/statementXml?statementId=${id}`)
    .then((res: any) => res);
}

export function statementXmlBase64(id: string): Promise<string> {
  return api
    .get(`statement/statementXmlBase64?statementId=${id}`)
    .then((res: any) => res);
}

export function sendPackage(data: any): Promise<object> {
  return api.post('statement/sendPackage', data).then((res: any) => res);
}

export function notifyAdditionalSigners(data: any): Promise<object> {
  return api
    .post('statement/notifyAdditionalSigners', data)
    .then((res: any) => res);
}

export function getFsspSubdivision(param: object): Promise<any> {
  return api.post('getFsspSubdivisions', param).then((res: any) => res);
}

//http://172.24.14.219:30080/api/lk/statement/statementXml?statementId=8f90763f-9046-47ce-ae20-10df3500e157

export function getStatementXml(statementId: string) {
  return api.get(`statement/statementXml?statementId=${statementId}`);
}
